import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import ATSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATSField";
import Attachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/Attachment";
import ETCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETCField";
import NotesField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/NotesField";
import RejectionReasonAndAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/RejectionReasonAndAttachment";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";
import IncidentsField from "../extra-fields/IncidentsField";
import NumberOfPackagesHandledField from "../extra-fields/NumberOfPackagesHandledField";
import ResourceField from "../extra-fields/ResourceField";
import SparesField from "../extra-fields/SparesField";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

const extraFieldsMap = {
  notes: () => <NotesField />,
  attachment: () => <Attachment isPdfonly={false} />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  numberOfPackagesHandled: (props: ExtraFieldProps) => <NumberOfPackagesHandledField {...props} />,
  spares: () => <SparesField />,
  incidents: () => <IncidentsField />,
  resources: (props: ExtraFieldProps) => <ResourceField {...props} />,
};

const closedFieldLayoutClassNames: Partial<Record<keyof typeof extraFieldsMap, string>> = {
  numberOfPackagesHandled: "col-start-1",
  incidents: "col-span-2",
  resources: "col-span-2",
};

type LoadingAndOffloadingExtraFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const LoadingAndOffloadingExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: LoadingAndOffloadingExtraFieldsProps) => {
  const isClosedStatus = selectedStatus === "CLOSED";

  return (
    <div
      className={
        isClosedStatus
          ? "grid grid-cols-2 gap-4 md:col-start-1 md:col-end-3"
          : "flex flex-col gap-2"
      }
    >
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];
              const fieldLayoutClassName = isClosedStatus
                ? (closedFieldLayoutClassNames[field] ?? "")
                : "";

              if (!FieldComponent) return null;

              return (
                <div className={`mt-4 ${fieldLayoutClassName}`.trim()} key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default LoadingAndOffloadingExtraFields;
